<kendo-dialog-titlebar>
    {{'admin-center.user.selectAbilityToAssign' | translate}}
</kendo-dialog-titlebar>

<form [formGroup]="assignAbilityForm">

    <list-combo-select-ctrl [caption]="'admin-center.user.ability'" [settings]="{fxFill:true}"
        [formControlName]="'abilityId'" [textField]="'description'" [valueField]="'id'"
        [valuesList$]="abilitiesList$"></list-combo-select-ctrl>

</form>

<kendo-dialog-actions>
    <button  type="button" kendoButton (click)="confirm()" [primary]="true">{{'global.confirm' | translate}}</button>
</kendo-dialog-actions>